export default __webpack_public_path__ + "static/media/Breach_artwork.e9e552aa.png";